import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

// Wave Q — operational page header (Premium-SaaS redesign, 2026-06-10).
//
// Replaces the loose `<h1>` + `<p>` pattern that was scattered across
// every tab with an explicit, slot-based header. Every tab now opens
// with the same structural information:
//
//   - eyebrow:   ONE quiet nav-group label (sentence-case, tertiary)
//   - title:     page name (confident, sentence-case)
//   - subtitle:  one-line operational purpose (sentence-case, secondary)
//   - meta:      inline status pills (sentence-case, tertiary)
//   - bottleneck: single-line callout when something is blocking
//   - action:    primary CTA (right side)
//   - updated:   "Updated 4m ago" caption (right side, below action, sentence-case)
//
// Visual contract is in studio.css under .studio-page-header.
//
// This is intentionally NOT a slotful render-prop component — the
// shape is fixed because consistency across tabs is the whole point.
// If a tab needs more fields, add them here, not as a one-off.

export function PageHeader({
  eyebrow,
  title,
  subtitle,
  meta,
  bottleneck,
  action,
  updated,
  className,
}) {
  return (
    <header
      className={['studio-page-header', className].filter(Boolean).join(' ')}
    >
      <div className="studio-page-header-main">
        {eyebrow ? (
          <div className="studio-page-header-eyebrow">{eyebrow}</div>
        ) : null}
        {title ? <h1 className="studio-page-header-title">{title}</h1> : null}
        {subtitle ? (
          <p className="studio-page-header-subtitle">{subtitle}</p>
        ) : null}
        {meta && meta.length > 0 ? (
          <div className="studio-page-header-meta">
            {meta.map((item, i) => (
              <span key={`meta-${i}`} className="studio-page-header-meta-item">
                {i > 0 ? (
                  <span className="studio-page-header-meta-sep">·</span>
                ) : null}{' '}
                {item}
              </span>
            ))}
          </div>
        ) : null}
        {bottleneck ? (
          <div
            className="studio-page-header-bottleneck"
            role="status"
            aria-live="polite"
          >
            <span
              className="studio-page-header-bottleneck-icon"
              aria-hidden="true"
            >
              <ExclamationTriangleIcon width={14} height={14} />
            </span>
            <span className="studio-page-header-bottleneck-label">
              Bottleneck
            </span>
            <span>{bottleneck}</span>
          </div>
        ) : null}
      </div>
      {(action || updated) && (
        <div className="studio-page-header-side">
          {action ? <div>{action}</div> : null}
          {updated ? (
            <div className="studio-page-header-updated">{updated}</div>
          ) : null}
        </div>
      )}
    </header>
  )
}
